import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import Element from '../Element/index.js';
import Heading from '../Heading/index.js';
import { genericMemo } from '../../utils/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};

function Header(props) {
  const {
    className,
    headingClassName,
    descriptionClassName,
    iconsContainerClassName,
    headingContainerClassName,
    actionsContainerClassName,
    inlineHeadingDescription,
    heading,
    description,
    actions,
    icons,
    headingSize,
    children,
    headingSectionClassName,
    childrenContainerClassName,
    elementProps,
    spacing = 'comfortable',
    ellipsizeHeading
  } = props;
  return /*#__PURE__*/React.createElement("header", _extends({
    className: _cs(styles.header, spacingToStyleMap[spacing], className)
  }, elementProps), /*#__PURE__*/React.createElement(Element, {
    className: _cs(styles.headingSection, headingSectionClassName),
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    actions: actions,
    actionsContainerClassName: actionsContainerClassName,
    spacing: spacing,
    childrenContainerClassName: _cs(styles.headingContainer, inlineHeadingDescription && styles.inlineDescription, headingContainerClassName)
  }, /*#__PURE__*/React.createElement(Heading, {
    size: headingSize,
    className: _cs(styles.heading, headingClassName),
    ellipsize: ellipsizeHeading
  }, heading), description && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.description, descriptionClassName, !headingSize && styles.uppercase, headingSize === 'large' && styles.uppercase, headingSize === 'medium' && styles.uppercase)
  }, description)), children && /*#__PURE__*/React.createElement("div", {
    className: childrenContainerClassName
  }, children));
}

var Header$1 = genericMemo(Header);

export { Header$1 as default };
//# sourceMappingURL=index.js.map
